<twc-side-navigation
  [menuItems]="menuItems()"
  [action]="createAction"
  [(expanded)]="sidebarState.expanded"
></twc-side-navigation>
